import { Component, OnInit, Input } from '@angular/core';
import  { Project } from '../project'
import { PatentService } from '../patent.service'

@Component({
  selector: 'app-patent-menu',
  templateUrl: './patent-menu.component.html',
  styleUrls: ['./patent-menu.component.css']
})
export class PatentMenuComponent implements OnInit {
  @Input() project: Project

  constructor(
    private ps: PatentService
  ) { }

  ngOnInit() {
  }

  get countries() {
    return this.ps.patentCountriesLs(this.project)
  }

  get stages() {
    return this.ps.patentStagesLs(this.project)
  }

}



// WEBPACK FOOTER //
// ./src/app/patent-menu/patent-menu.component.ts